import React from "react";
import { Box, Typography, Card, CardContent, LinearProgress } from "@mui/material";

export default function CreditScoreSummary({ data }) {
  const { score, rating, change, scale } = data;

  return (
    <Card
      sx={{
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.default",
      }}
    >
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary">
          Credit Score
        </Typography>
        <Typography variant="h3" fontWeight="bold">{score}</Typography>
        <Typography variant="body2" color="text.secondary" mb={1}>
          Rating: {rating} • Change: {change}
        </Typography>

        {/* Scale bar */}
        <Box sx={{ mt: 2 }}>
          <Typography variant="caption" color="text.secondary">
            Score Range
          </Typography>
          <LinearProgress
            variant="determinate"
            value={(score - 300) / (850 - 300) * 100}
            sx={{
              height: 10,
              borderRadius: 5,
              bgcolor: "grey.800",
              "& .MuiLinearProgress-bar": {
                backgroundColor: scale.color || "primary.main",
              },
            }}
          />
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.5 }}>
            <Typography variant="caption">Poor (300)</Typography>
            <Typography variant="caption">Exceptional (850)</Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
